import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AdminErrorBoundary } from "./admin/AdminErrorBoundary";
import MarketingSite from "./MarketingSite";

// Admin app is lazy-loaded so the public bundle doesn't ship admin code +
// react-router-dom isn't a hard dep of the marketing flow. Wrapped in an
// error boundary so chunk-load failures (stale cached index.html after a
// deploy) and any other render-time throws surface as a visible message
// instead of silently unmounting the tree to body bg ("black screen").
const AdminApp = lazy(() => import("./admin/AdminApp"));

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<MarketingSite />} />
        <Route
          path="/admin/*"
          element={
            <AdminErrorBoundary>
              <Suspense fallback={<AdminLoading />}>
                <AdminApp />
              </Suspense>
            </AdminErrorBoundary>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

function AdminLoading() {
  return (
    <div className="min-h-screen grid place-items-center bg-void text-mystic font-terminal">
      loading admin…
    </div>
  );
}
